/**
 * History icon button for section headers
 * Story 232: View history of changes and undo them
 *
 * Displays a clock icon that opens the history modal when clicked.
 * Shows on hover/active state alongside delete button.
 */

interface HistoryIconButtonProps {
  /** Called when button is clicked */
  onClick: () => void;
  /** Whether button should be visible (typically true when section hovered or active) */
  visible?: boolean;
}

export function HistoryIconButton({
  onClick,
  visible = true,
}: HistoryIconButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent parent handlers from interfering
    onClick();
  };

  return (
    <button
      onClick={handleClick}
      style={{
        padding: '4px 8px',
        fontSize: '14px',
        color: 'var(--text-muted, #94a3b8)',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        borderRadius: '4px',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      title="View history"
      aria-label="View section history"
    >
      {/* Clock icon (Unicode) */}
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Clock circle */}
        <circle cx="12" cy="12" r="10" />
        {/* Clock hands */}
        <polyline points="12 6 12 12 16 14" />
      </svg>
    </button>
  );
}
